// base
import React from "react";
import { Link } from "react-router-dom";

// components
import { StateButton, Button } from "../../components";

import { fromNow, wei2Daon, wei2CustomValue, substring } from "../../../helper";

// assets
import arrow from "../../assets/images/transactions/arrow.png";
import "./transactionsOverview.scss";

const TransactionsOverview = (props) => {
  const { transaction } = props;
  if (!transaction) return null;

  const {
    status,
    reason,
    blockNumber,
    type,
    value,
    fromAddress,
    toAddress,
    gasPrice,
    gasUsed,
    gasLimit,
    nonce,
    timestamp,
    txContract,
    isContract,
  } = transaction;

  return (
    <div className="TransactionsOverview">
      <div className="transaction_state">
        <StateButton status={status} reason={reason} />
      </div>
      <div className="responsive_table">
        <table className="table_type02 transactionOverview-table">
          <tbody>
            <tr>
              <th>TX Type</th>
              <td>{type}</td>
              <th>Amount</th>
              <td>
                {wei2Daon(value)}
                <small className="u-gray"> DEB</small>
              </td>
            </tr>
            <tr>
              <th>Block #</th>
              <td>
                <Link to={`/blocks/detail/${blockNumber}`} className="link">
                  {blockNumber}
                </Link>
              </td>
              <th>Gas Price</th>
              <td>
                {/*{gasPrice}*/}
                {wei2CustomValue(gasPrice, -9, 9)}
                <small className="u-gray"> Gwei</small>
              </td>
            </tr>
            <tr>
              <th>
                From
                <img className="transaction_arrow" src={arrow} alt="부터" />
                To
              </th>
              <td>
                <Button
                  color="blue"
                  link={`/account/${fromAddress}`}
                  tooltip={fromAddress}
                >
                  {substring(fromAddress)}
                </Button>
                <img className="transaction_arrow" src={arrow} alt="부터" />
                <Button
                  color="blue"
                  link={`/account/${toAddress}`}
                  tooltip={toAddress}
                >
                  {substring(toAddress)}
                </Button>
              </td>
              <th>Gas Used</th>
              <td>{gasUsed}</td>
            </tr>
            <tr>
              <th>Time</th>
              <td>{fromNow(timestamp)}</td>
              <th>Gas Limit</th>
              <td>{gasLimit}</td>
            </tr>
            <tr>
              <th>Nonce</th>
              <td>{nonce}</td>
              <th>TX Fee</th>
              <td>
                {wei2CustomValue(gasUsed * gasPrice, -18, 9)}
                <small className="u-gray"> DEB</small>
              </td>
            </tr>
            {txContract && (
              <tr>
                <th>Contract</th>
                <td style={{ borderRight: "1px solid #e2e2e2" }}>
                  <Button
                    color="blue"
                    tooltip={txContract}
                    link={`/${
                      isContract ? "contract" : "account"
                    }/${txContract}`}
                  >
                    {substring(txContract, 10)}
                  </Button>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TransactionsOverview;
